import React from 'react';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { Route, Routes, unstable_HistoryRouter as HistoryRouter } from 'react-router';
import { history, persistor, runSaga, store } from './redux/store';
import MainScreen from './screens/MainScreen/MainScreen';
import HomeScreen from './screens/HomeScreen/HomeScreen';
import rootSaga from './redux/root.saga';
import TokenLoginScreen from './screens/TokenLoginScreen/TokenLoginScreen';
import JobsScreen from './screens/JobsScreen/JobsScreen';
import { PersistGate } from 'redux-persist/integration/react';
import IntroductionScreen from './screens/IntroductionScreen/IntroductionScreen';
import ScrollToTop from './components/common/ScrollToTop/ScrollToTop';
import ManagementScreen from './screens/ManagementScreen/ManagementScreen';
import LoginScreen from './screens/LoginScreen/LoginScreen';
import HelpScreen from './screens/HelpScreen/HelpScreen';
import PageNotExists from './screens/404/PageNotExists';
import EvaluationScreen from './screens/EvaluationScreen';
import UnknownUserReadingScreen from './screens/UnknownUserReadingScreen/UnknownUserReadingScreen';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import CommunicationProvider from './screens/common/Communication/CommunicationProvider';
import CheckUpdates from './screens/common/CheckUpdates';
import { AccessibilityScreen } from './screens/AccessibilityScreen';
import { UnsavedChangesGuardProvider } from './screens/common/UnsavedChangesGuard/UnsavedChangesGuard';
import AiReadingScreen from './screens/AiReadingScreen/AiReadingScreen';

dayjs.extend(duration);

runSaga(rootSaga);

function App() {
    return (
        <div id={'App'}>
            <HelmetProvider>
                <Provider store={store}>
                    <PersistGate persistor={persistor}>
                        {/* history comes from redux-first-history, so sagas can navigate via push()/replace() */}
                        <HistoryRouter history={history as any}>
                            <UnsavedChangesGuardProvider>
                                <CheckUpdates />
                                <ScrollToTop />

                                <Routes>
                                    <Route
                                        path={'/accessibility/*'}
                                        element={
                                            <MainScreen showNavBarIfNotLoggedIn={true}>
                                                <AccessibilityScreen />
                                            </MainScreen>
                                        }
                                    />
                                    <Route path={'/m/:token/*'} element={<TokenLoginScreen />} />
                                    <Route
                                        path={'/ablesung-ohne-zugang'}
                                        element={
                                            <MainScreen showNavBarIfNotLoggedIn={true}>
                                                <UnknownUserReadingScreen />
                                            </MainScreen>
                                        }
                                    />
                                    <Route
                                        path={'*'}
                                        element={
                                            <MainScreen>
                                                <LoginScreen>
                                                    <CommunicationProvider>
                                                        <Routes>
                                                            <Route path={'/'} element={<HomeScreen />} />
                                                            <Route path={'/ai-ablesung'} element={<AiReadingScreen />} />
                                                            <Route path={'/ablesung'} element={<JobsScreen />} />
                                                            <Route path={'/ablesung/:jobId'} element={<JobsScreen />} />
                                                            <Route path={'/auswertung'} element={<EvaluationScreen />} />
                                                            <Route path={'/auswertung/:jobId'} element={<EvaluationScreen />} />
                                                            <Route path={'/introduction/*'} element={<IntroductionScreen />} />
                                                            <Route path={'/management/*'} element={<ManagementScreen />} />
                                                            <Route path={'/help/*'} element={<HelpScreen />} />
                                                            <Route path={'*'} element={<PageNotExists />} />
                                                        </Routes>
                                                    </CommunicationProvider>
                                                </LoginScreen>
                                            </MainScreen>
                                        }
                                    />
                                </Routes>
                            </UnsavedChangesGuardProvider>
                        </HistoryRouter>
                    </PersistGate>
                </Provider>
            </HelmetProvider>
        </div>
    );
}

export default App;
